import { links } from "./links";

// Content for the Join page. Rich text is Markdown.
// The subcommittee details on this page reuse the shared `committees` module.

export const joinTitle = "JOIN THE FIGHT FOR DETROIT TO DIVEST!";

export const joinLede =
  "Anyone who is opposed to the genocide in Palestine, who thinks money should go to Detroit and not to war, and wants to divest the Motor City from war profiteers should join the Detroit Anti-War Committee.";

export const joinCtaLabel = "Join our mailing list";
export const joinCtaUrl = links.mailingList;

export const getInvolvedHeading = "Get Involved";

export const getInvolved: string[] = [
  "DAWC believes everyone can be an anti-war activist! We welcome people with all skill levels and experience in activism. Our group is a great place to get started, try new things, and learn alongside each other!",
  "You can expect us to have two or more events each month, including protests and teach-ins, alongside our bi-weekly meetings.",
];

export const meetingsHeading = "Meetings";

// When and where are pulled out of the sentence: they are the two facts someone
// scans for, and the address is more use as a tap-through to directions.
export const meetingWhenLabel = "When";
export const meetingWhen = "Every other Thursday, 6pm";

export const meetingWhereLabel = "Where";
export const meetingVenue = "St. Peter's Episcopal Church";
export const meetingAddress = "1950 Trumbull Ave, Detroit";

export const meetings: string[] = [
  "Our General Meetings are always open to the public. We ask all newcomers to download the **Signal** app, as this is the app we use to communicate between meetings. At the General Meeting, we will add you to our Announcements chat. Additionally, we invite all new members to join any of our three subcommittees, which meet on a bi-weekly basis via Zoom.",
];

// export const subcommitteesHeading = "What Are the Subcommittees?";
export const subcommitteesHeading = "Subcommittees";

export const subcommitteesIntro ="";
  // "Each one carries a different piece of the Detroit Divest campaign, and every one of them needs people.";
